import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "gfu-search-form" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  class: "gfu-search-form-panel",
  "data-qa": "search-form:Panel"
}
const _hoisted_4 = { class: "gfu-search-form-panel__header _px-3 _px-4--m _py-1 _py-0--m _gap-3--m" }
const _hoisted_5 = {
  key: 0,
  class: "gfu-search-form-panel__close"
}
const _hoisted_6 = {
  ref: "resultsContainer",
  class: "gfu-search-form-results _pb-5 _pb-0--m _flexcol _gap-2"
}
const _hoisted_7 = {
  key: 0,
  class: "gfu-search-form-results__section gfu-search-form-results__section--recently-viewed",
  "data-qa": "search-form:RecentlyViewed"
}
const _hoisted_8 = { class: "gfu-search-form-results__section-title _flex _ai-c _px-3 _px-4--m _ma-0" }
const _hoisted_9 = ["data-qa"]
const _hoisted_10 = { class: "gfu-search-form-results__section-title _flex _ai-c _px-3 _px-4--m _ma-0" }
const _hoisted_11 = { class: "gfu-search-form-results__pills _flex _gap-2 _px-3 _px-4--m _py-1" }
const _hoisted_12 = ["href", "data-qa"]
const _hoisted_13 = {
  key: 1,
  class: "gfu-search-form-results__message _flex _ai-c _jc-c _px-3 _px-4--m _py-7 _ma-0",
  "data-qa": "search-form:MinimumCharactersHint"
}
const _hoisted_14 = {
  key: 2,
  class: "gfu-search-form-results__section",
  "data-qa": "search-form:Results"
}
const _hoisted_15 = { class: "gfu-search-form-results__heading _flex _jc-sb _ai-c _gap-2 _px-3 _px-4--m" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 1,
  ref: "searchResultsList",
  class: "gfu-search-form-results__list"
}
const _hoisted_19 = {
  key: 3,
  class: "gfu-search-form-results__message _flex _ai-c _jc-c _px-3 _px-4--m _py-7 _ma-0",
  "data-qa": "search-form:EmptyState"
}
const _hoisted_20 = { class: "gfu-search-form-results__section-title _flex _ai-c _px-3 _px-4--m _ma-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_drawer_header = _resolveComponent("drawer-header")
  const _component_search_field = _resolveComponent("search-field")
  const _component_skeleton_search_form_item = _resolveComponent("skeleton-search-form-item")
  const _component_creators_line = _resolveComponent("creators-line")
  const _component_search_form_item = _resolveComponent("search-form-item")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "gfu-search-form__trigger gfu-field__input gfu-field__input--soft _flex _ai-c _gap-1 _px-2",
      "aria-label": _ctx.Resources.Layout.SearchFormSearchButtonLabel,
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.openOverlay && $options.openOverlay(...args))),
      "data-qa": "search-form:Trigger"
    }, [
      _createVNode(_component_base_icon, { name: "search" }),
      _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Layout.SearchFormPlaceholder), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_2),
    (_openBlock(), _createBlock(_resolveDynamicComponent($options.overlayComponent), _mergeProps($options.overlayProps, _toHandlers($options.overlayListeners)), {
      default: _withCtx(() => [
        ($options.isDrawer)
          ? (_openBlock(), _createBlock(_component_drawer_header, {
              key: 0,
              onClose: $options.closeOverlay
            }, null, 8 /* PROPS */, ["onClose"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_search_field, {
              ref: "input",
              modelValue: $data.formModel.term,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.formModel.term) = $event)),
              placeholder: _ctx.Resources.Layout.SearchFormPlaceholder,
              class: "gfu-search-form-fields _grow-1",
              onKeydown: _withKeys(_withModifiers($options.onInputEnterKeyPress, ["prevent","stop"]), ["enter"]),
              "data-qa": "search-form:Input"
            }, null, 8 /* PROPS */, ["modelValue", "placeholder", "onKeydown"]),
            (!$options.isDrawer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "gfu-link gfu-link--accent _flex _ai-c _gap-1",
                    onClick: _cache[2] || (_cache[2] = (...args) => ($options.closeOverlay && $options.closeOverlay(...args))),
                    "data-qa": "search-form:Close"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Common.ModalCloseButton), 1 /* TEXT */),
                    _createVNode(_component_base_icon, { name: "times" })
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            ($options.showInitialDiscovery)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($data.isRecentlyViewedProcessing || $data.recentlyViewedProjects.length)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                        _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.Resources.Layout.SearchFormRecentlyViewedTitle), 1 /* TEXT */),
                        ($data.isRecentlyViewedProcessing && !$data.recentlyViewedProjects.length)
                          ? (_openBlock(), _createBlock(_component_skeleton_search_form_item, {
                              key: 0,
                              count: $data.recentlyViewedProjectsLimit
                            }, null, 8 /* PROPS */, ["count"]))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recentlyViewedProjects, (project, index) => {
                          return (_openBlock(), _createBlock(_component_search_form_item, {
                            key: `recent-${project.projectID}`,
                            url: project.projectUrl,
                            title: project.name,
                            "ref-options": $options.buildSearchRefOptions(index, 'recently-viewed'),
                            "thumb-image-url": project.imageUrl,
                            class: "gfu-search-form-results__item _px-3 _px-4--m _py-1",
                            "data-qa": `search-form-recently-viewed:${project.projectID}`
                          }, {
                            subtitle: _withCtx(() => [
                              _createVNode(_component_creators_line, {
                                creator: { name: project.creatorName },
                                "co-creators": project.coCreators
                              }, null, 8 /* PROPS */, ["creator", "co-creators"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["url", "title", "ref-options", "thumb-image-url", "data-qa"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.discoverySections, (section) => {
                    return (_openBlock(), _createElementBlock("section", {
                      key: section.key,
                      class: "gfu-search-form-results__section gfu-search-form-results__section--discovery",
                      "data-qa": `search-form-discovery:${section.key}`
                    }, [
                      _createElementVNode("h2", _hoisted_10, _toDisplayString(section.title), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item, index) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: item.url,
                            href: item.url,
                            class: "gfu-search-form-results__pill _flexinline _ai-c _gap-1 _shrink-0 _px-2 _py-1",
                            "data-qa": `search-form-${section.key}-discovery-link:${index}`
                          }, [
                            (item.icon)
                              ? (_openBlock(), _createBlock(_component_base_icon, {
                                  key: 0,
                                  name: item.icon,
                                  "aria-hidden": "true"
                                }, null, 8 /* PROPS */, ["name"]))
                              : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString(item.label), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_12))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ], 8 /* PROPS */, _hoisted_9))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($options.showMinimumCharactersHint)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.Resources.Layout.SearchFormMinimumCharactersHint), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.isLoading || $options.showSearchResults)
              ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    ($options.showSearchResults)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_ctx.Resources.Layout.SearchFormResultsProjectsCountLabel) + " ", 1 /* TEXT */),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.totalItemCount), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createBlock(_component_skeleton_wrapper, {
                          key: 1,
                          class: "gfu-search-form-results__heading-skeleton"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_skeleton_line, { height: 8 })
                          ]),
                          _: 1 /* STABLE */
                        })),
                    _createElementVNode("a", {
                      href: $options.searchResultsUrl,
                      class: "gfu-link gfu-link--accent",
                      "data-qa": "search-form:ViewMore"
                    }, _toDisplayString(_ctx.Resources.Layout.SearchFormViewMoreLink), 9 /* TEXT, PROPS */, _hoisted_17)
                  ]),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_skeleton_search_form_item, {
                        key: 0,
                        count: _ctx.pageSize
                      }, null, 8 /* PROPS */, ["count"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedItems, (project, index) => {
                          return (_openBlock(), _createBlock(_component_search_form_item, {
                            key: `project-${project.projectID}`,
                            "ref-options": $options.buildSearchRefOptions(index),
                            url: project.projectPageUrl,
                            title: project.name,
                            "thumb-image-url": project.thumbImageUrl,
                            class: "gfu-search-form-results__item _px-3 _px-4--m _py-1",
                            "data-qa": `search-form-results-projects:${project.projectID}`
                          }, {
                            subtitle: _withCtx(() => [
                              _createVNode(_component_creators_line, {
                                creator: project.creator,
                                "co-creators": project.coCreators
                              }, null, 8 /* PROPS */, ["creator", "co-creators"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["ref-options", "url", "title", "thumb-image-url", "data-qa"]))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createCommentVNode(" The top margin keeps the trigger just outside a full five-row list,\r\n                             so the next page loads only once the user scrolls. "),
                        (_ctx.canLoadMore)
                          ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                              key: 0,
                              class: "_mt-1",
                              onLoadMore: _ctx.loadMore,
                              "data-qa": "search-form:LoadMore"
                            }, null, 8 /* PROPS */, ["onLoadMore"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.isLoadingMore)
                          ? (_openBlock(), _createBlock(_component_skeleton_search_form_item, { key: 1 }))
                          : _createCommentVNode("v-if", true)
                      ], 512 /* NEED_PATCH */))
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.isEmpty)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.Resources.Layout.SearchFormEmptyState), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($options.shouldShowRecommendations && ($data.isRecommendationsProcessing || $options.recommendationProjects.length))
              ? (_openBlock(), _createElementBlock("section", {
                  key: 4,
                  class: _normalizeClass(['gfu-search-form-results__section', { '_mt-a': !$options.showInitialDiscovery }]),
                  "data-qa": "search-form:Recommendations"
                }, [
                  _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.Resources.ProjectHome.ProjectRecommendationsTitle), 1 /* TEXT */),
                  ($data.isRecommendationsProcessing && !$options.recommendationProjects.length)
                    ? (_openBlock(), _createBlock(_component_skeleton_search_form_item, {
                        key: 0,
                        count: $data.recommendationsLimit
                      }, null, 8 /* PROPS */, ["count"]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.recommendationProjects, (project) => {
                    return (_openBlock(), _createBlock(_component_search_form_item, {
                      key: `recommendation-${project.projectID}`,
                      url: project.url,
                      title: project.name,
                      "ref-options": project.refOptions,
                      "thumb-image-url": project.recommendationImageUrl,
                      class: "gfu-search-form-results__item _px-3 _px-4--m _py-1",
                      "data-qa": `search-form-recommendation:${project.projectID}`
                    }, {
                      subtitle: _withCtx(() => [
                        _createVNode(_component_creators_line, {
                          creator: project.creator,
                          "co-creators": project.coCreators
                        }, null, 8 /* PROPS */, ["creator", "co-creators"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["url", "title", "ref-options", "thumb-image-url", "data-qa"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ], 512 /* NEED_PATCH */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */))
  ]))
}